import gal2 from '../../assets/Gallery/gal2.jpeg';
import gal4 from '../../assets/Gallery/gal4.jpeg';
import gal5 from '../../assets/Gallery/gal5.jpeg';
import gal6 from '../../assets/Gallery/gal6.jpeg';
import gal7 from '../../assets/Gallery/gal7.jpeg';
import gal8 from '../../assets/Gallery/gal8.jpg';
import gal9 from '../../assets/Gallery/gal9.jpg';
import gal10 from '../../assets/Gallery/gal10.jpg';
import gal11 from '../../assets/Gallery/gal11.jpeg';
import gal12 from '../../assets/Gallery/gal12.jpeg';
import gal13 from '../../assets/Gallery/gal13.png';
// import gal13 from '../assets/Gallery/gal13.png';
import gal15 from '../../assets/Gallery/gal15.png';
import gal16 from '../../assets/Gallery/gal16.png';
import gal17 from '../../assets/Gallery/gal17.png';
import gal18 from '../../assets/Gallery/gal18.png';
import gal19 from '../../assets/Gallery/gal19.png';
import gal20 from '../../assets/Gallery/gal20.jpg';
import gal21 from '../../assets/Gallery/gal21.jpg';
import gal22 from '../../assets/Gallery/gal22.jpg';
import gal23 from '../../assets/Gallery/gal23.jpg';
import gal24 from '../../assets/Gallery/gal24.jpg';
import gal25 from '../../assets/Gallery/gal25.jpg';
import gal26 from '../../assets/Gallery/gal26.jpg';
// import gal27 from '../assets/Gallery/gal27.jpg';
import gal28 from '../../assets/Gallery/gal28.jpg';
import gal29 from '../../assets/Gallery/gal29.jpg';
import gal30 from '../../assets/Gallery/gal30.jpg';
import gal31 from '../../assets/Gallery/gal31.jpg';
import gal32 from '../../assets/Gallery/gal32.jpg';
import gal33 from '../../assets/Gallery/gal33.jpg';
import gal34 from '../../assets/Gallery/gal34.jpg';







export const CG = [

  {
    image: gal28,
    description: 'Prof.Dr.K.Venkatasubbaiah Garu',
  },
  {
    image: gal29,
    description: 'Prof.Dr.K.Venkatasubbaiah Garu',
  },
  {
    image: gal30,
    description: 'Prof.Dr.K.Venkatasubbaiah Garu',
  },
  {
    image: gal31,
    description: 'Prof.Dr.K.Venkatasubbaiah Garu',
  },
  {
    image: gal32,
    description: 'Prof.Dr.K.Venkatasubbaiah Garu',
  },
  {
    image: gal2,
    description: 'JNTUGV Library: Where Knowledge Is Unlocked And Minds Are Empowered',
  },
  {
    image: gal4,
    description: 'Jawaharlal Nehru Technological University-Gurajada, Vizianagaram (JNTU-GV) Logo',
  },
  {
    image: gal5,
    description: 'Intensity, teamwork, and raw athleticism on display - the college Kabaddi match is a thrilling showcase of passion and skill, uniting the campus in the spirit of sportsmanship.',
  },
  {
    image: gal6,
    description: 'Where minds converge and knowledge blooms - the vibrant college classroom is a dynamic space where teachers inspire, and students embark on a journey of discovery and growth.',
  },
  {
    image: gal7,
    description: 'A 3 days National Level Workshop was conducted at the JNTUGV auditiorium on the topic - Analog and Digital CMOS VLSI Design Using Microwind EDO Tool.',
  },
  {
    image: gal8,
    description: '27 students of JNTUGV got placed',
  },
  {
    image: gal9,
    description: '27 students of JNTUGV got placed',
  },
  {
    image: gal10,
    description: 'BR Ambedhkar Jayanthi at JNTUGV',
  },
  {
    image: gal11,
    description: 'During the Smart India Hackathon 2023 - Software Edition Grand Finale held at Veer Surendra Sai University of Technology (VSSUT) in Burla, Sambalpur, Odisha, a talented team from Jawaharlal Nehru Technological University-Gurajada, Vizianagaram, excelled in addressing the problem statement of Sentimental Analysis on Social Media Presence. The team, comprising Bandi Jaya Sai Srikar, Dudekula Meeravali, Aari Eswar, Penagaluru Bhanodhar, Pappala Archana, and Pyla Sandeep from the Information Technology branch, showcased their expertise, dedication, and innovative solutions. Their exceptional efforts resulted in commendable achievements, contributing significantly to the hackathons success.',
  },
  {
    image: gal12,
    description: 'During the Smart India Hackathon 2023 - Software Edition Grand Finale held at Veer Surendra Sai University of Technology (VSSUT) in Burla, Sambalpur, Odisha, a talented team from Jawaharlal Nehru Technological University-Gurajada, Vizianagaram, excelled in addressing the problem statement of Sentimental Analysis on Social Media Presence. The team, comprising Bandi Jaya Sai Srikar, Dudekula Meeravali, Aari Eswar, Penagaluru Bhanodhar, Pappala Archana, and Pyla Sandeep from the Information Technology branch, showcased their expertise, dedication, and innovative solutions. Their exceptional efforts resulted in commendable achievements, contributing significantly to the hackathons success.',
  },
  {
    image: gal13,
    description: 'National Library Week 2023 on the occasion of Nehru Jayanti at JNTU-Gurajada Vizianagaram College. Under the theme - Theres More to the Story, we honor Nehrus legacy and his belief in educations transformative power, especially through libraries.',
  },
  // {
  //   image: gal13,
  //   description: 'National Library Week 2023 on the occasion of Nehru Jayanti at JNTU-Gurajada Vizianagaram College. Under the theme - Theres More to the Story, we honor Nehrus legacy and his belief in educations transformative power, especially through libraries.',
  // },
  {
    image: gal15,
    description: 'Time to share exciting moment of JNTUGV.... Honorable VC Sir, Respected Registrar Madam and Respective Sports Authorities are Encouraging our Athletes who are Selected for Boxing which is going to held in Chandigarh',
  },
  {
    image: gal16,
    description: 'Completed an insightful CRT seminar hosted by THE DICES Institution! 📚✨ Sharpened the students skills in aptitude, verbal ability, and reasoning. Ready to tackle new challenges! 💪',
  },
  {
    image: gal17,
    description: 'Gurajada 161th birthday celebrations at JNTU Gurajada Viziangaram',
  },
  {
    image: gal18,
    description: 'Gurajada 161th birthday celebrations at JNTU Gurajada Viziangaram',
  },
  {
    image: gal19,
    description: 'Gurajada 161th birthday celebrations at JNTU Gurajada Viziangaram',
  },
  {
    image: gal20,
    description: 'Celebrating National Library Week at JNTUGV',
  },
  {
    image: gal21,
    description: 'Celebrating National Library Week at JNTUGV',
  },
  {
    image: gal22,
    description: 'Celebrating National Library Week at JNTUGV',
  },
  {
    image: gal23,
    description: 'Celebrating National Library Week at JNTUGV',
  },
  {
    image: gal24,
    description: 'Vice chanchellor Dr.K.Venkatasubbaiah Garu presenting Doctorate to Prof R.Gurunadha',
  },
  {
    image: gal25,
    description: 'Celebrating New Years at JNTUGV',
  },
  {
    image: gal26,
    description: 'Celebrating release of New Year Calenders at JNTUGV',
  }, {
    image: gal33,
    description: `తేదీ. 03-12-2024 :
      విజయనగరం.
      JNTU GV లో లెర్నింగ్ ఇంప్రూవ్మెంట్ ప్రోగ్రాం సర్టిఫికెట్లు అందజేత
      
      స్థానిక జవహర్ లాల్ నెహ్రూ సాంకేతిక
      విశ్వవిద్యాలయం గురజాడ విజయనగరం నందు  ఈరోజు జరిగిన కార్యక్రమంలో గౌరవనీయులు జెఎన్టియు జీవి వైస్-చాన్సులర్ ప్రొఫెసర్ K. వెంకటసుబ్బయ్య గారు, జెఎన్టియు జీవి రిజిస్ట్రార్ ప్రొఫెసర్ G. జయ సుమ గారు మరియు యూనివర్సిటీ BCDE (Board of community development through education) కోఆర్డినేటర్ Dr. G.J. నాగరాజు గారు learning improvement program లో పాల్గొన్న JNTU GV కళాశాల కు చెందిన 43 మంది విద్యార్థులకు సర్టిఫికెట్లు అందజేశారు.
       ప్రభుత్వం ఏర్పాటు చేసిన బి సి డి ఇ లో భాగంగా యూనివర్సిటీ ప్రోత్సాహంతో ఈ లెర్నింగ్ ఇంప్రూవ్మెంట్ ప్రోగ్రాంలను నిర్వహిస్తున్నారు. దీనిలో భాగంగా కళాశాల విద్యార్థులు జిల్లా పరిధిలో గల వివిధ ప్రభుత్వ పాఠశాలలకు వెళ్లి అక్కడ  అవగాహన కార్యక్రమాలు నిర్వహించి పాఠశాల విద్యార్థులకు సాంకేతికత మరియు పర్సనాలిటీ డెవలప్మెంట్ వంటి అనేక వాటిపై అవగాహన కల్పిస్తున్నారు. ఈ ట్రైనింగ్ కార్యక్రమంనకు వెళ్లిన విద్యార్థులకు ధృపత్రాలను అందచేసారు`,
  },
  {
    image: gal34,
    description: 'Distributing Certificates to the Students at JNTUGV',
  },
];
